import { Injectable } from '@angular/core';
import { ApiActions } from './util.service';
import { Subject } from 'rxjs';
import { Likes, Blogs } from 'src/app/model';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { MsgService } from './msg.service';
import { CommonDataService } from './common-data.service';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class LikesService {

  public pageName = 'Likes';
  public dataList = new Subject<Array<Likes>>();

  constructor(
    private http: HttpClient,
    private config: AppConfigService,
    private common: CommonDataService,
		private msgSvc: MsgService,
		private router: Router
  ) { }

  private getUrl(apiOption: ApiActions) {
    return this.config.ipAddress + this.config.LikesApi[apiOption];
  }

  public getDataRecords() {

    this.http.post(this.getUrl(ApiActions.Get), null, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result) {
          const dataArray: Array<Likes> = [];
          response.result.Likes.map(element => {
            element.status = element.rec_status + '' === '1' ? true : false;
            dataArray.push(element);
          });
          this.dataList.next(dataArray);
        }
      },
        err => {
            this.msgSvc.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
  }

  public getBlogs(type:number): Subject<Array<Blogs>> {
    const url = this.config.ipAddress + this.config.LikesApi[ApiActions.Delete];
    const dataArray: Array<Blogs> = [];
    const fData = new FormData();
    fData.append('type', type + '');
    const data = new Subject<Array<Blogs>>();
    this.http.post(url, fData, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result) {
          response.result.Blogs.map(element => {
           // element.status = Number(element.rec_status) === 1 ? true : false;
            dataArray.push(element);
          });
          data.next(dataArray);
        }
      },
        err => {
            this.msgSvc.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
    return data;
  }


  public addData(objData: Likes) {
    
    const fData = new FormData();
    fData.append('likes_id', objData.likes_id + '');
    fData.append('slike_id', objData.slike_id + '');
    fData.append('slike_type', objData.slike_type + '');

    return this.common.executeAction(fData, this.getUrl(ApiActions.Create), this.pageName);
  }

  public updateData(objData: Likes) {
    const fData = new FormData();
    fData.append('likes_id', objData.likes_id + '');
    fData.append('slikeid', objData.slike_id + '');
    fData.append('sliketype', objData.slike_type + '');
  
    return this.common.executeAction(fData, this.getUrl(ApiActions.Update), this.pageName);
  }

  public deleteData(id: number) {
    const fData = new FormData();
    fData.append('LikeId', id + '');
    return this.common.executeAction(fData, this.getUrl(ApiActions.Delete), this.pageName);
  }

  public updateStatus(objData: Likes) {
    const fData = new FormData();
    fData.append('stat', objData.status ? '1' : '0');
    fData.append('likesId', objData.likes_id + '');
    return this.common.executeAction(fData, this.getUrl(ApiActions.UpdateStatus), this.pageName);
  }
}
